export default [
  {
    path: '/:accountId/info/contact',
    name: 'contact',
    component: () => import('@/views/client/info/Contact.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Contact',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Contact',
          active: true,
        },
      ],
    },
  },
]
